import React from "react";
import { useNavigate } from "react-router-dom";

import { useQuery } from "../../utils/GeneralUtils";
import { PageVisibility } from "../../utils/PageVisibility";

type APIProps = {
  handleSearch?: (search: Array<string>) => void;
  clearSearch?: () => void;
  handleSort?: (sort: string) => void;
  handleStatus?: (status: string) => void;
  handlePeriod?: (period: string) => void;
  handleCategory?: (category: string) => void;
  handleCourse?: (course: string) => void;
  handleAccountType?: (accountType: string) => void;
  currentPage: number;
  perView: number;
  search?: Array<string>;
  sortBy?: string;
  status?: string | string[];
  period?: string;
  category?: string;
  searchCourse?: string;
  accountType?: string;
};

type Props = {
  apiComponent: React.FC<APIProps>;
};

const ManagementPageContainer: React.FC<Props> = ({
  apiComponent: APIComponent,
}) => {
  const query = useQuery();
  const navigate = useNavigate();

  const handleSort = (sort: string) => {
    query.delete("pg");

    query.delete("sort");
    query.set("sort", sort);

    navigate({ search: query.toString() });
  };

  const handleSearch = (s: Array<string>) => {
    query.delete("pg");

    query.delete("s");
    if (s.length > 0) {
      query.set("s", s.join(" "));
    }

    navigate({ search: query.toString() });
  };

  const clearSearch = () => {
    navigate({ search: "" });
  };

  const handleStatus = (status: string) => {
    query.delete("pg");

    query.delete("status");

    if (typeof status === "string" && status !== "all") {
      if (status === "default") {
        query.append("status", PageVisibility.PubliclyVisible);
        query.append("status", PageVisibility.AwaitingInspection);
      } else {
        query.set("status", status);
      }
    }

    navigate({ search: query.toString() });
  };

  const handlePeriod = (period: string) => {
    query.delete("pg");

    query.delete("period");
    if (period !== "default") {
      query.set("period", period);
    }

    navigate({ search: query.toString() });
  };

  const handleCategory = (category: string) => {
    query.delete("pg");

    query.delete("category");
    if (category !== "") {
      query.set("category", category);
    }

    navigate({ search: query.toString() });
  };

  const handleCourse = (course: string) => {
    query.delete("pg");

    query.delete("course");
    if (course !== "") {
      query.set("course", course);
    }

    navigate({ search: query.toString() });
  };

  const handleAccountType = (accountType: string) => {
    query.delete("pg");

    query.delete("accountType");
    if (accountType !== "") {
      query.set("accountType", accountType);
    }

    navigate({ search: query.toString() });
  };

  const paramToCurrentPage = (param: string | null) => {
    return param ? Number(param) : 1;
  };
  const paramToPerview = (param: string | null) => {
    return param ? Number(param) : 10;
  };
  const paramToSearchArray = (param: string | null) => {
    return param ? [...param.replace("　", " ").split(" ")] : [];
  };
  const paramToSort = (param: string | null) => {
    return param ? param : "_id";
  };
  const paramToStatus = (param: string | string[] | null) => {
    return param ? param : undefined;
  };
  const paramToPeriod = (param: string | null) => {
    return param ? param : undefined;
  };
  const paramToCategory = (param: string | null) => {
    return param ? param : undefined;
  };
  const paramToCourse = (param: string | null) => {
    return param ? param : undefined;
  };
  const paramToAccountType = (param: string | null) => {
    return param ? param : undefined;
  };

  // useEffect(() => {
  //   dispatch(requestTerms()).then(() => {
  //     setIsLoading(false);
  //   });
  // }, []);

  return (
    <APIComponent
      handleSearch={handleSearch}
      clearSearch={clearSearch}
      handleSort={handleSort}
      handleStatus={handleStatus}
      handlePeriod={handlePeriod}
      handleCategory={handleCategory}
      handleCourse={handleCourse}
      handleAccountType={handleAccountType}
      currentPage={paramToCurrentPage(query.get("pg"))}
      perView={paramToPerview(query.get("per"))}
      search={paramToSearchArray(query.get("s"))}
      sortBy={paramToSort(query.get("sort"))}
      status={paramToStatus(query.getAll("status"))}
      period={paramToPeriod(query.get("period"))}
      category={paramToCategory(query.get("category"))}
      searchCourse={paramToCourse(query.get("course"))}
      accountType={paramToAccountType(query.get("accountType"))}
    />
  );
};

export default ManagementPageContainer;
